import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalIssueNavigatorRoute: InvariantJiraRoute = {
	name: 'legacy-gin',
	path: '/issues/:issueKey(.*)?',
};
